import { AlertService } from './alert.service';
import { AppUtilsService } from './app-utils.service';
import { Injectable } from '@angular/core';
import {
    ActivatedRoute,
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { StarMoneyFacadeService } from '../core';
import { AuthService } from './auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class GuardService implements CanActivate {
    constructor(
        private route: Router,
        private activatedRoute: ActivatedRoute,
        private starMoneyFacadeService: StarMoneyFacadeService,
        private authService: AuthService,
        private alertService: AlertService
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            const bulk_id = route.queryParams['bulk_id'] || null;
            const txn_id = route.queryParams['txn_id'] || null;
            if (txn_id && localStorage.getItem('auth_session')) {
                return true;
            }
            const sessionId = bulk_id ?? txn_id;
            if (!localStorage.getItem('auth_session') && sessionId) {
                await this.authService.signIn(sessionId, !!bulk_id);
            }
            if (!txn_id && bulk_id) {
                const res = await this.starMoneyFacadeService.beginTxn({ bulk_application_id: bulk_id });
                if (res.statusCode === 200) {
                    // Merge both query params
                    this.route.navigate(['/home'], {
                        queryParams: {
                            bulk_id, // keep the original one
                            txn_id: res.data.txn_id // add new one
                        }
                    });
                }
            }

            return true;
        } catch (error) {
            await this.handleError(error);
            return false;
        }
    }


    /**
     * Handles errors in a consistent way
     * @param error The error to handle
     * @returns Always returns false to indicate error handling is complete
     */
    private async handleError(
        error: unknown,
        contextMessage: string = 'An unexpected error occurred'
    ): Promise<void> {
        let errorMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
        let logMessage = contextMessage;

        if (error instanceof HttpErrorResponse) {
            logMessage = `HTTP Error (${error.status}): ${error.message}`;

            const apiError = error.error?.error;
            const apiMessage = error.error?.message;

            errorMessage = apiError || errorMessage;
            errorMessage = apiMessage
                ? `${errorMessage} : ${apiMessage}`
                : errorMessage;

            console.error('API Error:', error.error);

            switch (apiError) {
                case "ONBOARDING.BULK_APPLICATION_NOT_FOUND":
                case "ONBOARDING.BULK_APPLICATION_NOT_STARTED":
                case "ONBOARDING.BULK_APPLICATION_ALREADY_ENDED":
                    errorMessage = "ไม่สามารถเข้าถึงข้อมูลการสมัครได้";
                    break;
            }
        } else if (error instanceof Error) {
            logMessage = `Error: ${error.message}`;
            errorMessage = error.message
            console.error(logMessage, error.stack);
        } else {
            logMessage = `${contextMessage}: ${String(error)}`;
            console.error(logMessage, error);
        }

        // this.appUtilsService.showAlertDialog({
        //     header: 'เกิดข้อผิดพลาด',
        //     message: errorMessage,
        //     acceptLabel: 'ตกลง',
        //     acceptCallback: () => console.log('ตกลง'),
        // });

        await this.alertService.showAlert(
            "เกิดข้อผิดพลาด",
            errorMessage,
            {
                onConfirm: async () => { await this.route.navigate(['/home']); }
            }, { confirmOnly: true })
    }
}
